import { cloneDeep } from 'lodash-es';
import { FetchDictMapResponseType } from '../api/sys/dict';

// 工单节点
export const createNode = (resolve: boolean, orderType: 10 | 20, all = false) => {
  const arr = [
    { name: '已下单', value: 10, hide: !all || !resolve }, // 没有待下单
    { name: '已审核', value: 20, hide: !all },
    { name: '已派单', value: 30 },
    { name: '已预约', value: 40 },
    { name: '已上门', value: 50 },
    { name: '已登记信息', value: 60, hide: orderType === 10 },
    { name: '已信息审核', value: 70, hide: orderType === 10 },
    { name: '已完工', value: 80 },
    { name: '已退单申请', value: 90, hide: !all },
    { name: '已客评', value: 100 },
    { name: '已入账', value: 110 },
  ].filter((item) => !item.hide);
  const result = cloneDeep(arr);
  if (!resolve) {
    result.forEach((item, index) => {
      delete item.hide;
      if (![90, 120, 130].includes(item.value)) {
        item.name = item.name.replace('已', '待');
      }
      // 第一个节点特殊处理，20为已审核的状态
      if (index === 0) {
        item.value = all ? 10 : 20;
      } else {
        // 使用上一个节点的id
        item.value = arr[index - 1].value;
      }
    });
    result[result.length - 1] = {
      name: '已入账',
      value: 110,
    };
  }
  return [{ name: '全部', value: 0 }, ...result];
};

// 本地全局字典，与服务端请求的字典合并
export const LocalDict: FetchDictMapResponseType = {
  // 已完成安装工单节点
  InstallNode: createNode(true, 10),
  // 已完成维修工单节点
  Node: createNode(true, 20),
  // 待完成安装工单节点
  WaitInstallNode: createNode(false, 10),
  // 待完成维修工单节点
  WaitNode: createNode(false, 20),
  // 操作人
  Operator: [
    { name: '客户', value: 1 },
    { name: '业务', value: 2 },
  ],
  // 审核类型
  ApproveType: [
    { name: '新网点入驻申请', value: 10 },
    { name: '老网点价格审核', value: 20 },
  ],
  // 价格类型
  CustomerPriceType: [
    { name: '自定义', value: 1 },
    { name: '标准价', value: 0 },
  ],
  // 客户账户状态
  AccountStatus: [
    { name: '欠款', value: 1 },
    { name: '正常', value: 2 },
  ],
  // 网点账户状态
  NetworkAccountStatus: [
    { name: '欠款', value: 1 },
    { name: '正常', value: 0 },
  ],
  // 到货情况,查询条件
  Arrival: [
    { name: '已到货', value: 1 },
    { name: '未到货', value: 0 },
  ],
  // 到货标识，表格使用
  ArrivalTable: [
    { name: '已到货', value: 1 },
    { name: '', value: 2 }, // 未到货，且无物流信息
    { name: '查物流', value: 3 },
  ],
  // 预约时间
  TimeType: [
    { name: '08:00~12:00', value: 10 },
    { name: '12:00~18:00', value: 20 },
    { name: '18:00~23:00', value: 30 },
  ],
  // 审核类型
  WarrantyApproveType: [
    { name: '保内⾃动审核', value: 10 },
    { name: '自费审核', value: 20 },
    { name: '质保未知审核', value: 30 },
  ],
  Parts: [
    { name: '待技术审核', alias: '已技术审核', value: 10 },
    { name: '待自购审核', alias: '已自购审核', value: 20 },
    { name: '待登记钉钉', alias: '已登记钉钉', value: 30 },
    { name: '待客户审核', alias: '已客户审核', value: 40 },
    { name: '仓库申请', alias: '已仓库申请', value: 50 },
    { name: '待发货', alias: '已发货', value: 60 },
    { name: '待签收', alias: '已签收', value: 70 },
    { name: '待返件', alias: '已返件', value: 80 },
    { name: '待返件签收', alias: '已返件签收', value: 90 },
    { name: '已完结', alias: '已完结', value: 100 },
    { name: '已驳回', alias: '已驳回', value: 110 },
    { name: '已取消', alias: '已取消', value: 120 },
  ],
  TypeApply: [
    { name: '商家寄发', value: 10 },
    { name: '商家向我购买', value: 20 },
  ],
};
